module.exports = __webpack_public_path__ + "img/18m.04bc8596.png";